import type { MerchantScheduleData } from '../types/get-merchant-details';
import { getNextOpeningTime } from '@/shared/utils/schedule';

interface ClosedStoreCardProps {
  scheduleData: MerchantScheduleData;
  /** Loja fechada porém aceitando pedidos agendados. */
  isSchedulable?: boolean;
}

export function ClosedStoreCard({ scheduleData, isSchedulable = false }: ClosedStoreCardProps) {
  const nextOpeningTime = getNextOpeningTime(scheduleData);

  return (
    <div className="bg-gray-900 rounded-xl p-4 mx-4 sm:mx-5 mb-4 shadow-lg">
      <div className="text-center space-y-1">
        <p className="text-white font-semibold text-sm">
          Loja fechada
        </p>
        <p className="text-gray-300 text-xs">
          {nextOpeningTime ? `Abre ${nextOpeningTime}` : 'Horários não disponíveis'}
        </p>
        {isSchedulable && (
          <p className="text-gray-200 text-xs pt-1">
            Você pode montar seu pedido e agendá-lo para mais tarde.
          </p>
        )}
      </div>
    </div>
  );
}
